{
  "manager": {
    "title": "Manager-Übersicht",
    "welcome": "Willkommen in Ihrem Management-Dashboard",
    "totalAppointments": "Termine gesamt",
    "todaysAppointments": {
      "title": "Heutige Termine",
      "noAppointments": "Keine Termine für heute geplant",
      "noAppointmentsHint": "Ihr Zeitplan ist heute frei.",
      "viewAll": "Kalender anzeigen",
      "anonymous": "Anonym",
      "resource": "Ressource {{id}}"
    },
    "completedThisWeek": "Diese Woche abgeschlossen",
    "activeClientLeads": "Aktive Kundenleads",
    "statusOverview": "Terminstatus-Übersicht",
    "completed": "Abgeschlossen",
    "scheduled": "Geplant",
    "confirmed": "Bestätigt",
    "inProgress": "In Bearbeitung",
    "cancelled": "Storniert",
    "quickActions": {
      "title": "Schnellaktionen",
      "scheduleAppointment": "Termin planen",
      "scheduleAppointmentDesc": "Neuen Termin für einen Kunden erstellen",
      "viewCalendar": "Kalender anzeigen",
      "viewCalendarDesc": "Alle Termine in der Kalenderansicht anzeigen",
      "manageLeads": "Leads verwalten",
      "manageLeadsDesc": "Alle Kundenleads anzeigen und verwalten",
      "manageResources": "Ressourcen verwalten",
      "manageResourcesDesc": "Personal, Räume & Ausstattung konfigurieren"
    },
    "scheduleNew": "Neuen Termin planen",
    "addNewClient": "Neuen Kunden hinzufügen",
    "viewCalendar": "Kalender anzeigen",
    "sendReminders": "Erinnerungen senden",
    "todaysAppointmentsCard": "Heutige Termine",
    "recentClientLeads": "Neueste Kundenleads",
    "upcomingAppointments": {
      "title": "Anstehende Termine",
      "noAppointments": "Keine anstehenden Termine",
      "noAppointmentsHint": "Planen Sie Termine, um sie hier zu sehen.",
      "viewAll": "Kalender anzeigen"
    },
    "noAppointmentsToday": "Keine Termine für heute geplant",
    "anonymousLead": "Anonymer Lead",
    "appointmentOverview": {
      "allOperational": "Alle Systeme betriebsbereit",
      "cancelled": "Abgesagt",
      "completed": "Vollendet",
      "confirmed": "Bestätigt",
      "noShow": "Keine Show",
      "scheduled": "Geplant",
      "title": "Terminübersicht"
    },
    "failedAppointments": "Termine konnten nicht geladen werden.",
    "failedLeads": "Leads konnten nicht geladen werden.",
    "leadPipeline": {
      "noLeads": "Noch keine Hinweise",
      "title": "Lead-Pipeline",
      "noLeadsHint": "Leads werden hier angezeigt, sobald sie über Ihre Kanäle erfasst werden."
    },
    "recentLeads": {
      "viewAll": "Alle anzeigen ({{count}})",
      "title": "Aktuelle Leads",
      "noLeads": "Keine Leads gefunden",
      "noLeadsHint": "Leads werden hier angezeigt, sobald sie erfasst werden."
    },
    "refresh": "Aktualisieren",
    "retry": "Wiederholen",
    "servicesUnreachable": "Einige Dienste sind nicht erreichbar",
    "stats": {
      "convertedLeads": "Konvertiert",
      "newLeads": "Neue Leads",
      "thisWeek": "Diese Woche",
      "todaysAppointments": "Heutige Termine",
      "totalAppointments": "Gesamtzahl der Termine",
      "totalLeads": "Gesamtzahl der Leads"
    },
    "loading": "Dashboard wird geladen...",
    "table": {
      "resource": "Ressource"
    }
  },
  "admin": {
    "title": "Admin-Übersicht",
    "welcome": "Willkommen im Admin-Bereich"
  },
  "client": {
    "title": "Kunden-Übersicht",
    "welcome": "Willkommen zurück",
    "subtitle": "Ihre Termine und Nachrichten auf einen Blick",
    "stats": {
      "upcomingThisWeek": "Diese Woche",
      "upcomingToday": "Heute",
      "totalAppointments": "Ihre Termine",
      "openThreads": "Nachrichten",
      "pendingRequests": "Offene Verschiebungsanfragen"
    },
    "upcomingAppointments": {
      "title": "Kommende Termine",
      "viewCalendar": "Kalender anzeigen",
      "empty": "Keine kommenden Termine",
      "anonymous": "Termin",
      "video": "Video",
      "inPerson": "Vor Ort"
    },
    "pendingRequests": {
      "title": "Offene Verschiebungsanfragen",
      "empty": "Keine offenen Verschiebungsanfragen",
      "requested": "Angefragt",
      "statuses": {
        "PENDING": "Ausstehend",
        "APPROVED": "Genehmigt",
        "REJECTED": "Abgelehnt",
        "CANCELLED": "Storniert"
      }
    },
    "changeRequest": {
      "title": "Terminänderung anfragen",
      "sendRequest": "Anfrage senden",
      "requestType": "Anfrageart",
      "typeReschedule": "Termin verschieben",
      "typeCancel": "Termin stornieren",
      "currentAppointment": "Aktueller Termin",
      "chooseNewTime": "Neue Uhrzeit wählen",
      "durationMinutes": "{{minutes}} Min.",
      "additionalInfo": "Zusätzliche Informationen",
      "additionalInfoPlaceholder": "Optionale Hinweise für den Anbieter",
      "cancelReason": "Stornierungsgrund",
      "appointmentLabel": "Termin",
      "deadlineBlocked": "Dieser Termin beginnt in einer Stunde oder weniger und kann online nicht mehr geändert werden. Bitte kontaktieren Sie uns direkt.",
      "activeRequestExists": "Für diesen Termin liegt bereits eine Änderungsanfrage vor.",
      "pendingOnAppointment": "Eine Änderungsanfrage für diesen Termin wird geprüft.",
      "rescheduleInfo": "Das gewählte Datum und die Uhrzeit bedürfen der Bestätigung. Ihr Termin wird erst nach Genehmigung verschoben.",
      "cancelInfo": "Ihr Termin wird sofort storniert und der Zeitslot wird freigegeben.",
      "rescheduleSubmitted": "Ihre Verschiebungsanfrage wurde erfolgreich übermittelt. Sie erhalten eine Bestätigung nach der Prüfung.",
      "cancelSubmitted": "Ihr Termin wurde erfolgreich storniert.",
      "cancelAppointment": "Termin stornieren",
      "alreadyCancelled": "Dieser Termin wurde bereits storniert.",
      "sameTimeAsCurrent": "Bitte wählen Sie ein anderes Datum und eine andere Uhrzeit als Ihren aktuellen Termin.",
      "submitFailed": "Die Änderungsanfrage konnte nicht gesendet werden."
    },
    "quickActions": {
      "title": "Schnellaktionen",
      "viewCalendar": "Kalender",
      "requestChange": "Änderung anfragen",
      "messages": "Nachrichten",
      "profile": "Profil"
    },
    "scopeRequired": {
      "dashboard": "Wählen Sie oben einen Mandanten und einen Kunden aus, um das Kundenportal anzuzeigen",
      "calendar": "Wählen Sie oben einen Mandanten und einen Kunden aus, um den Kalender anzuzeigen",
      "threads": "Wählen Sie oben einen Mandanten und einen Kunden aus, um die Unterhaltungen anzuzeigen",
      "thread": "Wählen Sie oben einen Kunden aus, um diese Unterhaltung anzuzeigen"
    },
    "calendar": {
      "subtitle": "Ihre Termine im Überblick"
    }
  }
}
